import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import "./ApiDocs.css";

const ApiDocs = () => {
  const [loading, setLoading] = useState(true);

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <div className="api-docs-container">
      {loading && (
        <div className="api-docs-loading">
          <Spin size="large" />
          <div className="api-docs-loading-text">加载 API 文档中...</div>
        </div>
      )}
      <iframe
        src="/redoc.html"
        className="api-docs-iframe"
        title="API Documentation"
        onLoad={handleLoad}
        frameBorder="0"
      />
    </div>
  );
};

export default ApiDocs;
